import { Pencil } from "lucide-react";
import { Button } from "react-aria-components";

type EditButtonProps = {
  /** Names the field in the accessible name ("Edit <label>"). */
  label: string;
  onPress: () => void;
};

export function EditButton({ label, onPress }: EditButtonProps) {
  return (
    <Button
      aria-label={`Edit ${label}`}
      className="cursor-pointer rounded-md p-1 text-fg-quaternary outline-hidden transition-colors hover:bg-bg-primary-hover hover:text-fg-brand-primary"
      onPress={onPress}
    >
      <Pencil className="size-4" />
    </Button>
  );
}
